import { TradeContext, TradeState } from './trade';
import ROUTES from '../../components/Routes/constants';

const ompStateRoutes = {
  [TradeContext.Buy]: {
    [TradeState.purchase]: ROUTES.OMP_PURCHASE,
    [TradeState.closing]: ROUTES.OMP_BUY_CLOSING
  },
  [TradeContext.Sell]: {
    [TradeState.closing]: ROUTES.OMP_SELL_CLOSING,
    [TradeState.arrived]: ROUTES.OMP_SELL_ARRIVED
  }
};

export default ompStateRoutes;
